const soScActions = {
  SO_SC_SELECTION: "SO_SC_SELECTION",
  soScSelection: (sosc) => ({
    type: soScActions.SO_SC_SELECTION,
    payload: sosc,
  }),
};

export default soScActions;
